import { useMemo } from 'react'
import axios from 'axios'
import type { UseAgentSessionOptions } from '../agent/useAgentSession'
import type { ComposerModel } from '../agent'
import useAgentModels from './useAgentModels'
import { AGENT_PLUGINS, getAuthToken, platinumV2Endpoints } from '../utils/agentTransport'

/**
 * What a page hands PageAgentPane so its helper chat is an ordinary agent chat:
 * the chat page's endpoints, auth, render plugins and model list. A page
 * helper's `sessionOptions` identity is stable per customer and model offering.
 */
export default function usePageAgentHost(customer: string) {
  const agentModels = useAgentModels()
  const authHeader = axios.defaults.headers.common['Authorization'] as string | undefined
  const sessionOptions: UseAgentSessionOptions = useMemo(() => ({
    apiBaseUrl: '',
    endpoints: platinumV2Endpoints(customer),
    defaultModel: agentModels.defaultModel,
    getAuthToken,
    authHeader,
    pluginEventTypes: AGENT_PLUGINS.flatMap(p => p.eventTypes),
  }), [customer, agentModels.defaultModel, authHeader])
  return { sessionOptions, plugins: AGENT_PLUGINS, models: agentModels.models as ComposerModel[] }
}
